import React from "react";
import { PageModule } from "../components/PageModule";

export interface ImageContentModuleProps {
  image: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  layout: "image-left" | "image-right";
}

export const ImageContentModule = ({
  image,
  content,
  className,
  layout,
}: ImageContentModuleProps) => {
  return (
    <PageModule className={`p-0 md:flex-row ${className ?? ""}`}>
      <div className={`flex-1 ${layout === "image-right" ? "md:order-2" : ""}`}>
        <div className="relative h-auto w-auto md:h-full">{image}</div>
      </div>
      <div className={`flex-1 ${layout === "image-right" ? "md:order-1" : ""}`}>
        <div className="flex h-full items-center px-4 py-8 md:px-8 md:py-20 lg:px-20">
          {content}
        </div>
      </div>
    </PageModule>
  );
};
